import React from "react";
import {observer} from "mobx-react";
import {BookingSearchFieldsContainerBox} from "../common/booking-search-fields-container.box";
import {RecentBookingsStrategy} from "./recent-bookings.strategy";
import {NumericFieldEditorComponent} from "../../../../components/forms/numeric-field/numeric-field-editor.component";

export const RecentBookingsFieldsComponent: React.FC<{ strategy: RecentBookingsStrategy }> = observer((props) => {
    const fields = props.strategy.fields;

    return (
        <BookingSearchFieldsContainerBox>
            <NumericFieldEditorComponent field={fields.topCount} showClearButton={true} inputMode={"numeric"}/>
        </BookingSearchFieldsContainerBox>
    );
})